import React from 'react';
import PageHeader from './components/PageHeader';
import { useNavigate } from 'react-router-dom';

function UsersAndPermissionsLanding() {
  const navigate = useNavigate();

  const navItems = [
    { path: '/settings/users', label: 'Users & Access Setup', icon: '👥', description: 'Manage user accounts and access' },
    { path: '/settings/roles', label: 'Roles & Permissions Setup', icon: '🔐', description: 'Configure roles and permissions' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Users & Permissions Setup"
        subtitle="Manage user accounts, roles, and access control"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '800px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <div className="grid grid-cols-2 gap-4 justify-items-center">
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center p-6 bg-white rounded-lg w-full max-w-xs border-2 border-black hover:border-blue-500 hover:shadow-lg transition-all group"
              >
                <span className="text-5xl mb-3 group-hover:scale-110 transition-transform">{item.icon}</span>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.label}</h3>
                <p className="text-xs text-gray-500 text-center">{item.description}</p>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default UsersAndPermissionsLanding;
